import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import TechUserIcon from '../SvgIcons/TechUserIcon';
import DoctorUserIcon from '../SvgIcons/DoctorUserIcon';
import { formatTimestamp } from '../../helpers/time';

const useStyles = makeStyles(theme => ({
  message: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(0.5),
    maxWidth: '80%',
    minWidth: '60%',
    alignSelf: 'flex-start',
    '&.author-viewing': {
      alignSelf: 'flex-end'
    },
    '&.author-viewing > .message-content': {
      backgroundColor: theme.palette.primary.light
    }
  },
  messageContentWrapper: {
    backgroundColor: theme.palette.action.hover,
    padding: theme.spacing(1.5),
    display: 'flex'
  },
  messageContent: {
    marginLeft: theme.spacing(1.25)
  },
  timestamp: {
    fontSize: '0.8rem',
    float: 'right',
    color: theme.palette.text.secondary
  },
  authorName: {
    fontSize: '0.9rem'
  }
}));

const Message = ({ message, currentUserIsTheAuthor, authorType, authorName, sentAt }) => {
  const classes = useStyles();

  const messageClasses = [classes.message];
  const contentClasses = ['message-content', classes.messageContentWrapper];

  if (currentUserIsTheAuthor) {
    messageClasses.push('author-viewing');
  }

  return (
    <div className={messageClasses.join(' ')}>
      {!currentUserIsTheAuthor && <span className={classes.authorName}>{authorName}</span>}

      <Paper className={contentClasses.join(' ')} elevation={3}>
        <Avatar>
          {authorType === 'management' && <TechUserIcon />}
          {authorType === 'doctor' && <DoctorUserIcon />}
        </Avatar>
        <div className={classes.messageContent}>{message}</div>
      </Paper>
      <span className={classes.timestamp}>{formatTimestamp(sentAt)}</span>
    </div>
  );
};

Message.propTypes = {
  message: PropTypes.string.isRequired,
  currentUserIsTheAuthor: PropTypes.bool.isRequired,
  authorType: PropTypes.string.isRequired,
  authorName: PropTypes.string.isRequired,
  sentAt: PropTypes.string.isRequired
};

export default Message;
